module.exports = __webpack_public_path__ + "static/chilli-58fe641dfbd7d23b7a189770ff9c4ce4.png";